import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2582dce4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2582dce4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582dce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2582dce4')) {
      api.createRecord('2582dce4', component.options)
    } else {
      api.reload('2582dce4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2582dce4&scoped=true", function () {
      api.rerender('2582dce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/mallDefaultSetting/index.vue"
export default component.exports